import { SlotGameType1_21 } from '../SlotGameType1_21';

export class AmazingPanda21 extends SlotGameType1_21
{
}
